import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {
  ITableColumnConfig,
  ITableHeaderConfig,
} from 'src/app/components/tablecomponent/tablecomponent.constants';
import { NfsFileModel, reportNfsFileModel } from 'src/models/nfsfile.model';
import { CSVConverter } from 'src/services/csv/csvconverter.service';
import { DownloaderService } from 'src/services/download/downloader.service';

@Component({
  selector: 'app-visualizererrors',
  templateUrl: './visualizererrors.component.html',
  styleUrls: ['./visualizererrors.component.scss'],
})
export class VisualizererrorsComponent implements OnInit {
  public title = 'Visualizador de Erros';
  public list: NfsFileModel[] = [];
  constructor(
    @Inject(MAT_DIALOG_DATA)
    public data: { items: NfsFileModel[]; period: string },
    public dialogRef: MatDialogRef<VisualizererrorsComponent>
  ) {}

  public configTable: ITableColumnConfig[] = [
    {
      key: 'txt_file_name',
      label: 'Arquivo',
      size: '200px',
      columnsize: 7.5,
      alignment: 'left',
    },
    {
      key: 'xml_model',
      label: 'Modelo',
      size: '100px',
      columnsize: 7.5,
      alignment: 'left',
    },
    {
      key: 'errors_list',
      label: 'Erros',
      size: '1fr',
      columnsize: 7.5,
      alignment: 'left',
    },
  ];
  public TableHeaderConfig: ITableHeaderConfig = {
    background: 'var(--color-toptable)',
    color: 'var(--color-toptable-contrast)',
  };

  ngOnInit(): void {
    console.log(this.data);
    this.list = this.data.items || [];
  }

  download() {
    const converter = new CSVConverter();
    const csv = converter.fromJSONArray(reportNfsFileModel(this.list));
    console.log(csv);
    const downloader = new DownloaderService();
    downloader.downloadCSV(csv, this.data.period+".csv");
  }
}
